/*
 * 中部组件（定制）：柴发月度维保检查清单（MwMiddleDg）
 * 对应原 Maintian_sub_processes_DG_month 表单中 grid_110 ~ grid_520 的检查项，检查项为定制开发（不读配置表）
 * 流程变量沿用原表单：sw_start_N / sw_end_N / txt_start_N / txt_end_N（N=1~6）、ck_XXX / txt_aa_XXX / txt_ed_XXX、
 *   check_t / check_h、battery_table1、soh、cca_all、A_M、get_data_button、form1 / form2、card1；
 *   txt_n_XXX / txt_m_XXX / txt_s_XXX 为检查项文案（随表单提交，后端结单时写入异常明细）
 * 操作顺序：开始维护（步骤1开始）-> 逐项检查（上一项完成后才能填写下一项）-> 结束步骤 -> 开始下一步骤 ... -> 步骤6结束后尾部【确认完成】
 * 头部 / 尾部通过 ADAPTER（见 biz.useMiddle）了解本组件的状态，头尾组件无需修改
 * 依赖：core.js ui.js biz.js sync.js
 */
export default function installMiddleDg(MW) {
  var h = MW.h, ui = MW.ui, biz = MW.biz, util = MW.util, store = MW.store, api = MW.api;
  var v = biz.v;

  var N2 = ["正常", "异常"], N3 = ["正常", "异常", "不适用"];
  /* ---------- 检查项定义（文案取自原表单） ---------- */
  var STEPS = [
    {
      name: "柴发维保环境及外观检查",
      items: [
        { id: 110, extra: "th", m: "1.1 检查柴发机组房间环境温、湿度", s: "环境温度：0°C至50°C\n环境相对湿度：10%至90%\n注：对于室外应用时，超出范围时应重点关注" },
        { id: 120, m: "1.2 检查确认机组房间清洁程度及周边物品\n检查机组房间无漏水或异常孔洞\n检查照明设备", s: "房间清洁，机组周边无杂物或易燃易爆物品；\n机组房间无漏水迹象；集装箱式柴发机组，箱体对外预留管路接口应有防护措施；\n照明设备工作正常，应急照明可正常启动。" },
        { id: 130, m: "1.3 检查集装箱箱体外观\n检查集装箱柜门\n检查柴发机组表面\n检查柴发机组及集装箱箱体接地\n检查柴发机组曲轴箱呼吸口\n检查机组减震装置\n检查机组支撑及横梁\n检查发动机油壳底，以及柴油滤清器、油泵和滤清器底座\n检查发动机连接的各类胶管\n检查皮带\n检查冷却风扇、风扇网罩和保护罩等\n检查进风、排风百叶", s: "各类门体应开闭良好，门禁功能应正常；\n机组、箱体与接地体可靠连接，接地螺栓紧固无松动，螺栓、接地扁钢、铜编织带等无锈蚀、破损等异常；\n曲轴箱呼吸口应保持畅通，无遮挡或堵塞；\n根据检查结果，在机组本地关机状态下对设备进行必要的清洁；\n减震装置无松动、弹簧无弯曲变形；\n滤清器底座应无渗油、漏油；\n皮带应无松弛、磨损、裂纹等现象；\n冷却风扇、风扇网罩和保护罩应无松动等异常现象；\n进风、排风百叶转动轴及操作机构无锈蚀、卡滞，必要时使用润滑脂进行润滑。" },
      ],
    },
    {
      name: "柴发维保设备及辅助系统检查",
      items: [
        { id: 210, m: "2.1 检查消防主机\n检查消防防火阀\n检查消防排烟风机\n检查配电柜（箱）", s: "消防主机运行于自动状态，无异常告警\n防火阀应处于常开状态\n消防排烟风机可手动开启\n集装箱内配套的配电柜，面板显示电压正确，内部接线无松动等异常" },
        { id: 220, m: "2.2 检查机组本地控制器HMI\n检查机组本地控制器状态", s: "HMI应显示清晰，操作流畅，各类指示灯与实际状态一致\n机组状态与ECC显示状态一致，机组应处于远程或自动状态，各参数显示正常，无异常报警" },
        { id: 221, m: "2.21 读取机组参数设置并检查", s: "检查调压板及控制器内部接线有无松动，下载机组历史运行记录，分析异常的故障代码，检查机组内部设置参数，确认与SCP一致" },
        { id: 230, extra: "battery", m: "2.3 检查蓄电池外观\n检查蓄电池液位\n检查蓄电池充电器\n检查启动系统线缆\n测量蓄电池内阻", s: "蓄电池外观无变形、破损、表面结晶、电解液渗漏等异常\n富液式蓄电池电解液液位高于极板，且不低于蓄电池厂商规定的最低值，必要情况下添加蒸馏水\n启动系统线缆螺栓紧固无松动，电缆绝缘完好无破损，电池卡箍和连接端子应涂有凡士林\n关闭充电器，并断开蓄电池与柴发机组的连接，\n测量启动电池内阻，各单节电池内阻应≤4mΩ，\n同时单台机组配套电池内阻值与该组最小值偏差\n不应超过30%，与该组平均值偏差不应超过± 15%",
          // sd 仅用于展示：原文第 4 段是排版折行，合并后再编号；原文 s 会写入 txt_s_230，保持不变
          sd: "蓄电池外观无变形、破损、表面结晶、电解液渗漏等异常\n富液式蓄电池电解液液位高于极板，且不低于蓄电池厂商规定的最低值，必要情况下添加蒸馏水\n启动系统线缆螺栓紧固无松动，电缆绝缘完好无破损，电池卡箍和连接端子应涂有凡士林\n关闭充电器，并断开蓄电池与柴发机组的连接，测量启动电池内阻，各单节电池内阻应≤4mΩ，同时单台机组配套电池内阻值与该组最小值偏差不应超过30%，与该组平均值偏差不应超过± 15%" },
        { id: 232, extra: "soh", opts: N3, m: "2.3.1 启动电池容量检查", s: "SOH（电池容量）应大于80%（如无工具检测可不填）" },
        { id: 233, extra: "cca", opts: N3, m: "2.3.2 启动电池冷启动电流检查", s: "关闭充电器，并断开蓄电池与柴发机组的连接，CCA（电池冷启动电流）应大于90%（如无工具检测可不填）\n应减少频繁拆卸电池端头导致的金属疲劳损坏：\n1）此处测量并联的两组电池启动电流若大于1800A，则无需拆卸电池极柱的连接端头；\n2）并联的两组电池启动电流若小于1800A，则仅拆卸其中任意一组电池组的任意一极，断开两组并联后，即可测量单节电池的启动电流，确认大于900A。" },
        { id: 240, m: "2.4 检查蓄电池充电电压", s: "蓄电池充电器指示灯正常，显示充电电压（不应持续低于26V）、电流与实测值一致" },
        { id: 250, m: "2.5 检查冷却液液位\n检查散热器管路\n检查进、排风风道百叶/风阀", s: "冷却液液位不得低于柴发厂商规定的最低值\n散热器管路外观完好无泄漏，管路卡箍无松动。\n集装箱进排风百叶及对应风阀应处于自动控制状态，通过手动开关百叶/风阀，确认无卡死、异响等异常，测试手自动均可开闭进排风百叶及对应风阀后，方可允许进行启机测试" },
        { id: 260, m: "2.6 检查燃油油位\n日用油箱排污\n检查油水分离器\n检查供回油手动阀门\n检查供回油电动阀门\n检查回油泵", s: "日用油箱本地油位显示与磁翻板显示一致，且与ECC远程数据一致，油位应不低于正常满油量的70%\n通过日用油箱底部排污阀进行排污，检查油箱底部是否存在水分、杂质\n注：\n1) 可根据历史维护情况调整为1次/半年；\n2) 持续暴雨季节后可增加频次；\n油水分离器中无水分和沉积物注：若进行沉淀物排放，需确保维护后排放口被牢固拧紧，防止燃油系统进入空气\n各类手动阀门实际状态与挂牌状态一致\n各类电动阀门实际状态ECC远程数据一致注：供回油系统维护时可一并测试其联动功能\n回油泵状态与ECC远程数据一致注：供回油系统维护时可一并测试其联动功能" },
        { id: 270, m: "2.7 检查空气滤清器\n检查排气管路", s: "空气滤清器完好，无破损及脏污；尝试按压空气滤清器保养指示器不小于3次，指示器应能灵活复位；\n波纹管无变形；排气管路保温隔热材料包裹良好，无漏气等异常；" },
        { id: 280, m: "2.8 检查润滑油液位\n检查润滑油油质", s: "润滑油液位应在机油标尺的ADD和FULL之间\n检查机油标尺上的油质清澈无杂质，无乳化现象" },
        { id: 290, m: "2.9 检查水套加热器", s: "水套加热器低温环境下（低于16℃）下，水套加热器应处于正常工作状态，水温度应高于厂商建议的冷却液、润滑油温度" },
      ],
    },
    {
      name: "单机启动带假负载/空载测试",
      items: [
        { id: 310, m: "3.1 进线开关隔离", s: "将柴发应急进线打至手动位置" },
        { id: 320, m: "3.2 单机开启运行", s: "通过并机主控柜或远程（电力监控系统）启动柴发机组，机组应顺利启动：进排风百叶均处于正常开启状态；机组控制器无异常告警；机组无漏气、漏液、漏油等异常；冷却风扇转动顺畅，无异响；" },
        { id: 330, m: "3.3 柴发启动时，记录启动电池瞬间最低电压", s: "关闭启动蓄电池充电器，将带数据记录功能的万用表挂接在启动电池正负极之间，捕捉柴发启动瞬间的电压降最低值并记录，一般应≥15.2V，若不具备条件，则通过控制面板查看启动过程中的电池电压降瞬时值" },
        { id: 340, opts: N3, m: "3.4 检查机组对应的接地电阻柜", s: "机组对应的接地电阻柜接地电阻柜投入，面板无告警" },
        { id: 350, opts: N3, m: "3.5 逐步投入假负载", s: "建议单机负载率80%（月度计划空载可不执行此项）" },
        { id: 360, m: "3.6 检查机组控制器面板数据\n观察空气滤清器保养指示器\n检查柴发机组排气烟色\n检查洗烟装置工作情况（若有）\n检查消防设施状态\n核对后台远程数据", s: "机组各运行参数正常，含转速、输出电压、电流、频率、水温、润滑油压力等\n观察空气滤清器保养指示器，判断是否需要更换滤清器\n柴发机组启动瞬间产生黑烟，10秒内烟色基本变为无色\n洗烟装置排水正常，且无漏水现象\n柴发机组房间烟感、温感无异常告警\n柴发机组本地运行数据与ECC监控远程数据一致" },
      ],
    },
    {
      name: "单机柴发带载数据记录",
      sn: "3.7",
      items: [
        { id: 370, extra: "load", m: "3.7 单机柴发带载数据记录", s: "发动机：转速(RPM)；机油压力(KPA)；冷却水温(℃)；发电机：电压（V）；频率(HZ)；电流(A)；有功功率(KW)；视在功率(KVA)；功率因数(PF)" },
      ],
    },
    {
      name: "并机启动带假负载/空载测试",
      items: [
        { id: 410, m: "4.1 并机开启运行", s: "各台柴发机组在设计时间内完成并机" },
        { id: 420, m: "4.2 接地电阻柜检查", s: "仅有一台接地电阻柜投入" },
        { id: 430, m: "4.3 逐步投入假负载", s: "并机系统带假负载运行，有功功率、视在功率均分" },
      ],
    },
    {
      name: "关机恢复",
      items: [
        { id: 510, opts: N3, m: "5.1 关闭柴发机组", s: "柴发机组收到关机命令后，经延时冷却后停机" },
        { id: 520, opts: N3, m: "5.2 确认柴发机组及相关辅助设备恢复", s: "柴发机组恢复自动待机；其它辅助设备恢复默认正常状态；" },
      ],
    },
  ];
  /* 检查标准分段：每行一段；上一行以逗号结尾视为同段续行；"1）/1)/注：" 开头的行作为上一段的补充说明，不单独编号 */
  var STD_SUB_RE = /^(\d+\s*[)）]|注\s*[:：])/;
  function stdParas(s) {
    var out = [];
    String(s || "").split("\n").forEach(function (raw) {
      var line = raw.trim(), cur = out[out.length - 1];
      if (!line) return;
      var tail = cur ? (cur.sub.length ? cur.sub[cur.sub.length - 1] : cur.t) : "";
      if (cur && /[，,、]$/.test(tail)) {
        if (cur.sub.length) cur.sub[cur.sub.length - 1] += line; else cur.t += line;
      } else if (cur && STD_SUB_RE.test(line)) cur.sub.push(line);
      else out.push({ t: line, sub: [] });
    });
    return out;
  }
  function stdView(paras) {
    if (paras.length < 2) return h("p", null, paras.map(function (p) { return [p.t].concat(p.sub).join("\n"); }).join("\n"));
    return h("ol", { class: "mw-dg-std__list" }, paras.map(function (p, i) {
      return h("li", null,
        h("span", { class: "mw-dg-std__no" }, i + 1),
        h("div", { class: "mw-dg-std__txt" }, p.t, p.sub.map(function (x) { return h("small", null, x); })));
    }));
  }

  var NS = STEPS.length;
  var ITEMS = [], BY_ID = {};
  STEPS.forEach(function (st, si) {
    st.no = si + 1;
    st.items.forEach(function (it, k) {
      it.step = st.no;
      it.k = k;
      it.lines = it.m.split("\n");
      it.sn = (/^([\d.]+)\s*/.exec(it.lines[0]) || [])[1] || "";
      it.title = it.lines[0].replace(/^[\d.]+\s*/, "");
      it.checks = it.lines.slice(1);
      it.hasCk = it.extra !== "th" && it.extra !== "load";
      it.paras = stdParas(it.sd || it.s);
      ITEMS.push(it);
      BY_ID[it.id] = it;
    });
  });

  var PT = MW.points;
  var NUM_RE = /^[+-]?(\d+(\.\d*)?|\.\d+)$/;
  var TIME_RE = /^\d{4}-\d{2}-\d{2}/;

  var showErr = {}; // 步骤级校验错误展示
  var collapsed = {}; // 用户手动折叠 / 展开
  var fold = biz.folder(collapsed, function () {
    return STEPS.map(function (st) { return { id: st.no, started: swS(st.no), ended: swE(st.no) }; });
  });
  var busy = {}; // 开关请求中 { "s1": 1, "e3": 1, get: 1 }

  /* ---------- 取值与条件 ---------- */
  function lock() { return biz.isClosed(); }
  function on(k) { return v(k) === true; }
  function swS(n) { return on("sw_start_" + n); }
  function swE(n) { return on("sw_end_" + n); }
  function empty(x) { return util.isEmpty(x); }
  function stepSn(n) { return STEPS[n - 1].sn || String(n); }
  function ckOf(it) { return v("ck_" + it.id); }
  function isAbn(it) { return it.hasCk && ckOf(it) === "异常"; }
  function batRows() { return Array.isArray(v("battery_table1")) ? v("battery_table1") : []; }
  function cards() { return Array.isArray(v("card1")) ? v("card1") : []; }
  function autoMode() { return v("A_M") === "自动"; }
  /** 电池表：至少 2 节且每节电压、内阻已填 */
  function batteryOk() {
    var rows = batRows();
    return rows.length >= 2 && rows.every(function (r) { return !empty(r.bat_V) && !empty(r.bat_R); });
  }

  /** 检查项当前需要填写（可见即必填）的字段 -> [{key, var, msg}] */
  function missing(it) {
    var id = it.id, out = [];
    var need = function (name, val, msg) { if (empty(val) || val === false) out.push({ key: "dg." + id + "." + name, msg: msg || "该字段是必填字段" }); };
    if (it.extra === "th") {
      need("t", v("check_t"));
      need("h", v("check_h"));
      return out;
    }
    if (it.extra === "load") {
      if (autoMode()) {
        if (v("get_data_button") !== false) out.push({ key: "dg.370.get", msg: v("get_data_button") ? "请在数据记录完成后关闭【获取数据】" : "请打开【获取数据】记录带载数据，完成后关闭" });
      } else {
        out = PT.cardMissing(cards(), "dg.370");
      }
      return out;
    }
    var ck = ckOf(it);
    need("ck", ck);
    if (ck === "异常") {
      need("aa", v("txt_aa_" + id));
      need("ed", v("txt_ed_" + id));
    }
    if (it.extra === "soh" && ck === "正常") need("soh", v("soh"));
    if (it.extra === "cca" && ck === "正常") need("cca", v("cca_all"));
    if (it.extra === "battery") {
      var rows = batRows();
      if (rows.length < 2) out.push({ key: "dg.230.bat", msg: "请至少填写 2 节电池的电压与内阻" });
      rows.forEach(function (r, i) {
        if (empty(r.bat_V)) out.push({ key: "dg.230.bat." + i + ".V", msg: "请填写电压" });
        if (empty(r.bat_R)) out.push({ key: "dg.230.bat." + i + ".R", msg: "请填写内阻" });
      });
    }
    return out;
  }
  function itemDone(it) { return missing(it).length === 0; }
  /** 本步骤进行中（已开始、未结束） */
  function active(n) { return !lock() && swS(n) && !swE(n); }
  /** 检查项可填写：本步骤进行中，且本步骤上一项已完成 */
  function prevDone(it) {
    var st = STEPS[it.step - 1];
    return it.k === 0 || itemDone(st.items[it.k - 1]);
  }
  function itemEditable(it) {
    if (!active(it.step) || !prevDone(it)) return false;
    if (it.extra === "soh") return batteryOk();
    return true;
  }
  /** 电池表在 2.21 完成后才能填写 */
  function batEditable() { return active(2) && itemDone(BY_ID[221]); }

  /** 开始开关可操作：步骤 1 = 维护准备完成；其余 = 上一步骤已结束；均只能打开一次 */
  function startEditable(n) {
    if (lock() || swS(n)) return false;
    if (n === 1) return !on("sw_end") && biz.prepareDone();
    return swE(n - 1);
  }
  /** 结束开关可操作：本步骤已开始，且下一步骤未开始（步骤 6：尾部未确认完成） */
  function endEditable(n) {
    if (lock() || !swS(n)) return false;
    return n < NS ? !swS(n + 1) : !on("sw_end");
  }

  function stepErrors(n) {
    if (!swS(n)) return [{ key: "dg.s" + n + ".start", msg: "请打开开关" }];
    var e = [];
    STEPS[n - 1].items.forEach(function (it) { e = e.concat(missing(it)); });
    if (!swE(n)) e.push({ key: "dg.s" + n + ".end", msg: "请打开开关" });
    return e;
  }
  function stepStatus(n) {
    if (showErr[n] && stepErrors(n).length) return "error";
    if (swE(n)) return "done";
    if (swS(n)) return "doing";
    return "todo";
  }
  var ST = { todo: ["未开始", "muted", "ri-time-line"], doing: ["进行中", "info", "ri-loader-2-line"], done: ["已完成", "ok", "ri-checkbox-circle-line"], error: ["待完善", "danger", "ri-error-warning-line"] };

  function stats() {
    var done = 0, filled = 0, abn = 0;
    for (var n = 1; n <= NS; n++) if (swE(n)) done++;
    ITEMS.forEach(function (it) {
      if (swS(it.step) && itemDone(it)) filled++;
      if (isAbn(it)) abn++;
    });
    return { done: done, total: ITEMS.length, filled: filled, abn: abn, pct: Math.round((filled / ITEMS.length) * 100) };
  }

  /* ---------- 保存 ---------- */
  var sync = MW.sync;
  /** 选择类立即保存；输入类键入时只标记（1 秒防抖保存），失焦立即保存 */
  function setVal(k, val, typing) {
    store.set(k, val, typing ? { silent: true } : undefined);
    if (typing) sync.typing(k);
    else sync.save(k);
  }
  function saveMany(obj) {
    store.patch(obj);
    Object.keys(obj).forEach(function (k) { sync.save(k); });
  }
  function netFail(e, what) {
    if (util.isNetErr(e)) return ui.toast("网络不稳定，" + (what || "操作") + "已暂存，联网后自动上传", "warn");
    ui.toast("保存失败：" + (util.errMsg(e) || "服务异常") + "，将自动重试", "danger");
  }
  function scrollToStep(n) {
    setTimeout(function () {
      var el = MW.$("#mw-dg-step-" + n);
      if (el) util.scrollTo(util.pageTop(el) - (util.isMobileView() ? 12 : 16), true);
    }, 40);
  }

  /** 开始步骤（步骤 1 即【开始维护】，同时记录 txt_start 供头部 / 结单使用） */
  function onStart(n, val) {
    if (!val) return;
    var sw = "sw_start_" + n, label = n === 1 ? "开始维护" : "步骤 " + stepSn(n);
    busy["s" + n] = 1;
    store.touch(sw);
    sync.fresh()
      .then(function () {
        if (swS(n)) return sync.doneBy(sw, label, "开始");
        if (!startEditable(n)) return ui.toast("数据已更新，请按最新状态操作", "warn");
        var now = util.now(), o = {};
        o[sw] = true;
        o["txt_start_" + n] = now;
        if (n === 1) o.txt_start = now;
        store.patch(o);
        collapsed[n] = false;
        if (n > 1) collapsed[n - 1] = undefined;
        biz.saveLastPosition();
        return sync.commit(Object.keys(o), [sw]).then(function (r) {
          if (r && r.code === 1) return sync.doneBy(sw, label, "开始", r.rejected);
          if (r && r.offline) ui.toast(label + " 已在本机开始（当前无网络），联网后自动上传", "info");
          else if (n === 1) ui.toast("已开始维护，请按步骤逐项检查", "ok");
        });
      })
      .catch(function (e) { netFail(e); })
      .then(function () {
        delete busy["s" + n];
        store.touch(sw);
      });
  }

  /** 结束步骤：校验本步骤全部检查项；关闭（重新打开本步骤）仅在下一步骤未开始前允许 */
  function onEnd(n, val) {
    var sw = "sw_end_" + n, txt = "txt_end_" + n, label = "步骤 " + stepSn(n);
    if (!val) {
      return ui.confirm("确定重新打开" + label + "「" + STEPS[n - 1].name + "」吗？结束时间将被清除。", { title: "重新打开步骤" }).then(function () {
        if (!endEditable(n)) return ui.toast("数据已更新，请按最新状态操作", "warn");
        var o = {};
        o[sw] = false;
        o[txt] = "";
        store.patch(o);
        collapsed[n] = false;
        return sync.commit([sw, txt], []);
      }).catch(function () {});
    }
    busy["e" + n] = 1;
    store.touch(sw);
    sync.fresh()
      .then(function () {
        if (swE(n)) return sync.doneBy(sw, label, "完成");
        if (!endEditable(n)) return ui.toast("数据已更新，请按最新状态操作", "warn");
        var err = stepErrors(n).filter(function (x) { return !/\.end$/.test(x.key); });
        if (err.length) {
          showErr[n] = true;
          collapsed[n] = false;
          ui.toast(label + " 还有 " + err.length + " 项未填写", "warn");
          setTimeout(function () { ui.scrollToError(); }, 30);
          return;
        }
        showErr[n] = false;
        var o = {};
        o[sw] = true;
        o[txt] = util.now();
        store.patch(o);
        biz.saveLastPosition();
        return sync.commit([sw, txt], [sw]).then(function (r) {
          if (r && r.code === 1) return sync.doneBy(sw, label, "完成", r.rejected);
          collapsed[n] = undefined;
          if (r && r.offline) ui.toast(label + " 已在本机结束（当前无网络），联网后自动上传", "info");
          var abn = STEPS[n - 1].items.filter(isAbn).map(function (it) { return it.sn; });
          if (abn.length) ui.confirm('<div class="color-danger">检查项 ' + abn.join("、") + " 存在异常情况，请确认是否属实</div>", { title: "提示" }).catch(function () {});
        });
      })
      .catch(function (e) { netFail(e, "结束步骤"); })
      .then(function () {
        delete busy["e" + n];
        store.touch(sw);
      });
  }

  /* ---------- 电池内阻 ---------- */
  function calcDiffer(rows) {
    var rs = rows.map(function (r) { return NUM_RE.test(String(r.bat_R == null ? "" : r.bat_R).trim()) ? Number(r.bat_R) : null; });
    var nums = rs.filter(function (x) { return x !== null; });
    var avg = nums.length ? nums.reduce(function (a, b) { return a + b; }, 0) / nums.length : 0;
    rows.forEach(function (r, i) { r.differ = rs[i] === null || !avg ? "" : (((rs[i] - avg) / avg) * 100).toFixed(2); });
    return rows;
  }
  /** 内阻失焦：单节 > 4mΩ 或偏差超过 ±15% 时 2.3 判为异常（原 bat_R 失焦脚本） */
  function judgeBattery(rows, cur) {
    var o = { battery_table1: rows };
    if (Number(cur) > 4) o.ck_230 = "异常";
    else {
      var bad = [];
      rows.forEach(function (r, i) { if (r.differ !== "" && Math.abs(Number(r.differ)) > 15) bad.push(i + 1); });
      if (bad.length) {
        o.ck_230 = "异常";
        o.txt_ed_230 = ["测量" + bad.join("、") + "节电池内阻偏离均值较大,"];
      } else o.ck_230 = "正常";
    }
    if (o.ck_230 === "异常" && ckOf(BY_ID[230]) !== "异常") ui.toast("电池内阻超出标准，检查项 2.3 已自动判为异常，请补充异常部位", "warn");
    saveMany(o);
  }
  function batTable(err) {
    var dis = !batEditable();
    var rows = batRows();
    var setRow = function (i, f, val, typing) {
      var list = util.clone(batRows());
      if (!list[i]) return;
      list[i][f] = val;
      if (f === "bat_R") calcDiffer(list);
      setVal("battery_table1", list, typing);
    };
    var cell = function (i, f, ph) {
      var r = rows[i];
      return ui.field({ key: "dg.230.bat." + i + "." + (f === "bat_V" ? "V" : "R"), error: err("bat." + i + "." + (f === "bat_V" ? "V" : "R")) },
        ui.input({ name: "dg_bat_" + i + "_" + f, value: r[f], inputmode: "decimal", placeholder: ph, disabled: dis,
          onInput: function (val) { setRow(i, f, val, true); },
          onBlur: function (val) {
            if (f === "bat_R" && !empty(val)) judgeBattery(calcDiffer(util.clone(batRows())), val);
            else setRow(i, f, val);
          } }));
    };
    return h("div", { class: "mw-dg-bat", dataset: { key: "dg.230.bat" } },
      h("div", { class: "mw-dg-sec" }, h("i", { class: "ri-battery-2-charge-line" }), h("b", null, "启动电池电压与内阻"),
        h("small", null, dis && !lock() && active(2) ? "完成 2.21 后可填写" : "单节内阻应 ≤ 4mΩ，与平均值偏差不超过 ±15%"),
        h("span", { class: "mw-dg-sec__extra" }, ui.btn("添加电池", { type: "ghost", icon: "ri-add-line", size: "sm", disabled: dis, onClick: function () {
          var list = util.clone(batRows());
          list.push({ bat_V: "", bat_R: "", differ: "" });
          setVal("battery_table1", list);
        } }))),
      ui.rtable({
        cls: "mw-dg-rtable",
        empty: "请点击【添加电池】逐节录入",
        rows: rows,
        columns: [
          { title: "电池序号", cls: "is-idx", render: function (r, i) { return h("b", { class: "mw-dg-idx" }, i + 1); } },
          { title: "电压（V）", required: true, render: function (r, i) { return cell(i, "bat_V", "电压"); } },
          { title: "内阻（mΩ）", required: true, render: function (r, i) { return cell(i, "bat_R", "内阻"); } },
          { title: "内阻偏差比", render: function (r) {
            if (r.differ === "" || r.differ == null) return ui.text("");
            var bad = Math.abs(Number(r.differ)) > 15;
            return ui.tag((Number(r.differ) > 0 ? "+" : "") + r.differ + "%", bad ? "danger" : "ok", bad ? "ri-error-warning-line" : "ri-check-line");
          } },
          { title: "操作", cls: "is-ops", render: function (r, i) {
            return ui.btn("删除", { type: "text-danger", icon: "ri-delete-bin-6-line", size: "sm", disabled: dis, onClick: function () {
              var list = util.clone(batRows());
              list.splice(i, 1);
              setVal("battery_table1", calcDiffer(list));
            } });
          } },
        ],
      }),
      err("bat") && h("div", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), err("bat"))
    );
  }

  /* ---------- 带载数据记录（3.7） ---------- */
  function onGetData(val) {
    if (val && MW.net.offline) return MW.offline.needNet("获取测点数据");
    busy.get = 1;
    store.set("get_data_button", val);
    sync.save("get_data_button");
    api.call(val ? "get_zhiwei_data" : "end_get_form_data")
      .then(function (resp) {
        var r = resp && resp.data ? resp.data.result : null;
        if (r && r.status === "error") ui.toast(r.message || "请求过于频繁，请稍后再试", "warn");
        else ui.toast(val ? "已开始获取测点数据，约每 15 秒刷新一次" : "已结束获取数据", val ? "info" : "ok");
      })
      .catch(function (e) { ui.toast((val ? "获取数据" : "结束获取数据") + "失败：" + (util.errMsg(e) || "服务异常"), "danger"); })
      .then(function () { delete busy.get; store.touch("get_data_button"); });
  }
  /** 自动取数记录：后端同时写入 form1 / form2（内容相同），组件只读一份 */
  function pointView() {
    return PT.view(PT.rowsOf({ form1: v("form1"), form2: v("form2") }), "dg");
  }
  function loadBlock(it, err) {
    var dis = !active(4);
    var mode = v("A_M") || "手动";
    var head = h("div", { class: "mw-dg-sec" }, h("i", { class: "ri-database-2-line" }), h("b", null, "数据记录方式"),
      ui.tag(mode, mode === "自动" ? "info" : "muted", mode === "自动" ? "ri-robot-2-line" : "ri-edit-2-line"),
      h("small", null, mode === "自动" ? "由系统从动环测点自动获取" : "测点数据不可用，请人工填写"));
    if (mode === "自动") {
      var gb = on("get_data_button");
      var running = String(v("get_status")) === "1";
      return h("div", { class: "mw-dg-load" }, head,
        biz.switchRow({
          title: "获取数据", required: true, key: "dg.370.get", icon: "ri-download-cloud-2-line",
          time: gb ? (running ? "正在获取测点数据…" : "已请求获取，等待数据返回") : v("get_data_button") === false ? "已结束获取数据" : "单机带载运行后打开开关获取测点数据，记录完成后关闭",
          value: gb, disabled: dis, loading: !!busy.get, onChange: onGetData, error: err("get"),
          tip: dis && !lock() ? (swE(4) ? "步骤已结束" : "请先开始本步骤") : null, cls: "mw-step__sw",
        }),
        pointView());
    }
    return h("div", { class: "mw-dg-load" }, head,
      PT.cards({
        rows: cards(), prefix: "dg.370", name: "dg", disabled: dis, err: err, defaultName: v("device_name"),
        set: function (list, typing) { setVal("card1", list, typing); },
      }));
  }

  /* ---------- 渲染：检查项 ---------- */
  function itemCard(it, ctx) {
    var id = it.id;
    var show = showErr[it.step] || ctx.submitted;
    var miss = show ? missing(it) : [];
    var err = function (name) {
      var k = "dg." + id + "." + name;
      var e = miss.filter(function (x) { return x.key === k; })[0];
      return e ? e.msg : null;
    };
    var dis = !itemEditable(it);
    var waiting = active(it.step) && !prevDone(it);
    var done = swS(it.step) && itemDone(it);
    var abn = isAbn(it);
    var ck = ckOf(it);
    var ctrls = [], wide = null;

    if (it.hasCk) {
      ctrls.push(ui.field({ label: "检查结果", required: true, key: "dg." + id + ".ck", error: err("ck"), cls: "mw-sub__result" },
        ui.radio({ options: it.opts || N2, value: ck, disabled: dis, block: true, onChange: function (val) { setVal("ck_" + id, val); } })));
    }
    if (it.extra === "th") {
      ctrls.push(ui.grid(2, [
        ui.field({ label: "温度(℃)", required: true, key: "dg.110.t", error: err("t") },
          ui.input({ name: "dg_check_t", value: v("check_t"), inputmode: "decimal", placeholder: "0 ~ 50", disabled: dis,
            onInput: function (val) { setVal("check_t", val, true); }, onBlur: function (val) { setVal("check_t", val); } })),
        ui.field({ label: "湿度(%)", required: true, key: "dg.110.h", error: err("h") },
          ui.input({ name: "dg_check_h", value: v("check_h"), inputmode: "decimal", placeholder: "10 ~ 90", disabled: dis,
            onInput: function (val) { setVal("check_h", val, true); }, onBlur: function (val) { setVal("check_h", val); } })),
      ], "mw-grid--m1"));
      var t = Number(v("check_t")), hu = Number(v("check_h"));
      if ((!empty(v("check_t")) && (t < 0 || t > 50)) || (!empty(v("check_h")) && (hu < 10 || hu > 90)))
        ctrls.push(h("div", { class: "mw-alert mw-alert--warn" }, h("i", { class: "ri-temp-hot-line" }), h("div", null, "温湿度超出标准范围，请重点关注")));
    }
    if (it.extra === "soh" && ck !== "不适用") {
      ctrls.push(ui.field({ label: "电池容量(100%)", required: ck === "正常", key: "dg.232.soh", error: err("soh"), desc: "按 ≥ 80% 自动判定检查结果" },
        ui.input({ name: "dg_soh", value: v("soh"), inputmode: "decimal", placeholder: "如无工具检测可不填", disabled: dis,
          onInput: function (val) { setVal("soh", val, true); },
          onBlur: function (val) {
            if (NUM_RE.test(String(val).trim())) saveMany({ soh: val, ck_232: Number(val) >= 80 ? "正常" : "异常" });
            else setVal("soh", val);
          } })));
      if (!batteryOk() && active(2)) ctrls.push(h("div", { class: "mw-alert mw-alert--info" }, h("i", { class: "ri-information-line" }), h("div", null, "请先在 2.3 中填写至少 2 节电池的电压与内阻")));
    }
    if (it.extra === "cca" && ck !== "不适用") {
      ctrls.push(ui.field({ label: "电池冷启动电流(100%)", required: ck === "正常", key: "dg.233.cca", error: err("cca"), desc: "按 ≥ 90% 自动判定检查结果" },
        ui.input({ name: "dg_cca", value: v("cca_all"), inputmode: "decimal", placeholder: "如无工具检测可不填", disabled: dis,
          onInput: function (val) { setVal("cca_all", val, true); },
          onBlur: function (val) {
            if (NUM_RE.test(String(val).trim())) saveMany({ cca_all: val, ck_233: Number(val) >= 90 ? "正常" : "异常" });
            else setVal("cca_all", val);
          } })));
    }
    if (abn) {
      var tagSel = function (name, k, title, opts) {
        return ui.field({ label: title, required: true, key: "dg." + id + "." + name, error: err(name) },
          ui.tagSelect({ value: v(k) || [], options: opts || [], disabled: dis, title: title, placeholder: "选择或输入" + title,
            onChange: function (val) { setVal(k, val, true); }, onBlur: function (val) { setVal(k, val); } }));
      };
      ctrls.push(ui.grid(2, [
        tagSel("aa", "txt_aa_" + id, "异常部位", v("abnormal_area")),
        tagSel("ed", "txt_ed_" + id, "异常描述", v("abnormal_description")),
      ], "mw-grid--m1 mw-sub__abn"));
    }
    if (it.extra === "battery") wide = batTable(err);
    if (it.extra === "load") wide = loadBlock(it, err);
    if (waiting) ctrls.unshift(h("div", { class: "mw-alert mw-alert--info mw-dg-wait" }, h("i", { class: "ri-lock-2-line" }), h("div", null, "请先完成上一检查项")));

    var hasErr = miss.length > 0;
    return h(
      "article",
      { class: ["mw-sub", "mw-dg-item", abn && "is-abn", done && !abn && "is-ok", hasErr && "has-error", waiting && "is-wait", !ctrls.length && "is-wide"], id: "mw-dg-item-" + id, style: { animationDelay: Math.min(it.k, 8) * 30 + "ms" } },
      h("div", { class: "mw-sub__info" },
        h("div", { class: "mw-sub__head" },
          h("span", { class: "mw-sub__sn" }, it.sn),
          h("h4", null, it.title),
          abn ? ui.tag("异常", "danger", "ri-error-warning-fill") : done ? ui.tag(ck === "不适用" ? "不适用" : "已完成", done && ck === "不适用" ? "muted" : "ok", "ri-check-line") : null),
        it.checks.length > 0 && h("ul", { class: "mw-dg-checks" }, it.checks.map(function (c) { return h("li", null, c); })),
        h("div", { class: "mw-dg-std" }, h("b", null, h("i", { class: "ri-file-list-3-line" }), "检查标准"), stdView(it.paras))),
      ctrls.length > 0 && h("div", { class: "mw-sub__ctrl" }, ctrls),
      wide && h("div", { class: "mw-dg-wide" }, wide)
    );
  }

  /* ---------- 渲染：概览与步骤 ---------- */
  function ring(pct) {
    var r = 26, c = 2 * Math.PI * r;
    var svg = '<svg viewBox="0 0 64 64"><circle cx="32" cy="32" r="' + r + '" class="bg"/><circle cx="32" cy="32" r="' + r + '" class="fg" stroke-dasharray="' + c + '" stroke-dashoffset="' + c * (1 - pct / 100) + '"/></svg>';
    return h("div", { class: "mw-ring", html: svg + "<b>" + pct + "<small>%</small></b>" });
  }
  function startRow(ctx) {
    var editable = startEditable(1), started = swS(1), tip = null;
    if (!editable && !lock() && !started) tip = "请先在上方完成打卡、" + (biz.isSelf() ? "人脸识别、设备核对" : "上传设备照片") + "，再开始维护";
    if (started && !lock()) tip = "已开始维护，不可关闭";
    return h("div", { class: "mw-start", id: "mw-start" },
      biz.switchRow({
        title: "开始维护", required: true, key: "dg.s1.start", icon: "ri-play-circle-line",
        time: started ? "开始时间：" + (v("txt_start_1") || v("txt_start")) : "点击【开始维护】记录开始时间",
        value: started, disabled: !editable, loading: !!busy.s1, onChange: function (val) { onStart(1, val); },
        error: ctx.submitted && !started ? "请打开开关" : null, tip: tip, cls: "mw-swrow--hero",
      }));
  }
  function overview(ctx) {
    var s = stats();
    var cur = 0;
    for (var n = 1; n <= NS; n++) if (!swE(n)) { cur = n; break; }
    var curTxt = !swS(1) ? "未开始" : !cur ? "全部完成" : "步骤 " + stepSn(cur);
    var stat = function (icon, label, val, tone) {
      return h("div", { class: ["mw-stat", tone && "is-" + tone] }, h("i", { class: icon }), h("div", null, h("small", null, label), h("b", null, val)));
    };
    return ui.panel(
      { title: "检查清单", icon: "ri-list-check-3", id: "mw-checklist", sub: "柴发月度维保 · 开始维护 → 按步骤顺序：开始步骤 → 逐项检查 → 结束步骤", cls: "mw-overview" },
      startRow(ctx),
      h("div", { class: "mw-overview__top" },
        ring(s.pct),
        h("div", { class: "mw-overview__stats" },
          stat("ri-stack-line", "维护步骤", s.done + " / " + NS),
          stat("ri-checkbox-multiple-line", "检查项已填", s.filled + " / " + s.total, "info"),
          stat("ri-alarm-warning-line", "异常项", s.abn, s.abn ? "danger" : "ok"),
          stat("ri-focus-3-line", "当前进度", curTxt, !swS(1) ? "muted" : !cur ? "ok" : "info"))),
      h("div", { class: "mw-stepnav", role: "tablist" },
        STEPS.map(function (st) {
          var ss = stepStatus(st.no);
          return h("button", { type: "button", class: ["mw-stepnav__item", "is-" + ss], onClick: function () { collapsed[st.no] = false; store.touch(); scrollToStep(st.no); } },
            h("span", { class: "mw-stepnav__no" }, ss === "done" ? h("i", { class: "ri-check-line" }) : ss === "error" ? h("i", { class: "ri-error-warning-line" }) : st.no),
            h("span", { class: "mw-stepnav__name" }, st.name));
        }))
    );
  }
  function stepCard(st, ctx) {
    var n = st.no, ss = stepStatus(n), started = swS(n);
    var isCollapsed = fold.is(n, swE(n));
    var show = showErr[n] || ctx.submitted;
    var errOf = function (f) {
      if (!show) return null;
      var e = stepErrors(n).filter(function (x) { return x.key === "dg.s" + n + "." + f; })[0];
      return e && e.msg;
    };
    var items = st.items;
    var abnN = items.filter(isAbn).length;
    var doneN = items.filter(itemDone).length;
    var sTime = v("txt_start_" + n), eTime = v("txt_end_" + n);
    var sTip = null, eTip = null;
    if (!startEditable(n) && !lock()) sTip = started ? "步骤已开始" : n > 1 && !swE(n - 1) ? "请先结束步骤 " + stepSn(n - 1) : null;
    if (!endEditable(n) && !lock() && started) eTip = n < NS ? "下一步骤已开始，不可修改" : "已确认完成，不可修改";

    return h(
      "section",
      { class: ["mw-step", "mw-dg-step", "is-" + ss, isCollapsed && "is-collapsed", ss === "error" && "has-error"], id: "mw-dg-step-" + n, style: { animationDelay: Math.min(n, 6) * 40 + "ms" } },
      h("header", { class: "mw-step__head", onClick: function () { if (!started) return; collapsed[n] = !isCollapsed; store.touch(); } },
        h("span", { class: "mw-step__no" }, ss === "done" ? h("i", { class: "ri-check-line" }) : n),
        h("div", { class: "mw-step__title" },
          h("small", null, "维护步骤 " + stepSn(n)),
          h("h3", null, st.name),
          h("div", { class: "mw-step__meta" },
            ui.tag(ST[ss][0], ST[ss][1], ST[ss][2]),
            h("span", null, h("i", { class: "ri-checkbox-multiple-line" }), (started ? doneN : 0) + "/" + items.length + " 项"),
            abnN > 0 && h("span", { class: "is-danger" }, h("i", { class: "ri-alarm-warning-line" }), "异常 " + abnN),
            TIME_RE.test(sTime || "") && h("span", null, h("i", { class: "ri-play-line" }), String(sTime).slice(11, 16)),
            TIME_RE.test(eTime || "") && h("span", null, h("i", { class: "ri-stop-line" }), String(eTime).slice(11, 16)))),
        started && h("button", { type: "button", class: "mw-step__toggle", "aria-label": isCollapsed ? "展开" : "收起" }, h("i", { class: "ri-arrow-down-s-line" }))),
      h("div", { class: "mw-step__body" },
        n > 1 && biz.switchRow({
          title: "开始当前步骤", required: true, key: "dg.s" + n + ".start", icon: "ri-play-circle-line",
          time: TIME_RE.test(sTime || "") ? "步骤开始时间：" + sTime : "点击【开始维护】记录步骤" + stepSn(n) + "开始时间",
          value: started, disabled: !startEditable(n), loading: !!busy["s" + n], error: errOf("start"), tip: sTip,
          onChange: function (val) { onStart(n, val); }, cls: "mw-step__sw",
        }),
        n === 1 && !started && h("div", { class: "mw-alert mw-alert--info" }, h("i", { class: "ri-information-line" }), h("div", null, "打开上方【开始维护】后开始本步骤")),
        started && !isCollapsed && h("div", { class: "mw-step__subs" }, items.map(function (it) { return itemCard(it, ctx); })),
        started && isCollapsed && h("button", { type: "button", class: "mw-step__fold", onClick: function () { collapsed[n] = false; store.touch(); } },
          h("i", { class: "ri-eye-line" }), "查看 " + items.length + " 个检查项"),
        started && biz.switchRow({
          title: "结束当前步骤", required: true, key: "dg.s" + n + ".end", icon: "ri-flag-2-line",
          time: TIME_RE.test(eTime || "") ? "步骤结束时间：" + eTime : "完成全部检查项后，点击【确认完成】记录步骤" + stepSn(n) + "结束时间",
          value: swE(n), disabled: !endEditable(n), loading: !!busy["e" + n], error: errOf("end"), tip: eTip,
          onChange: function (val) { onEnd(n, val); }, cls: "mw-step__sw mw-step__sw--end",
        }))
    );
  }

  /* ---------- 中部适配器（头部 / 尾部 / 同步据此判断） ---------- */
  var KEYS = ["check_t", "check_h", "battery_table1", "soh", "cca_all", "A_M", "get_data_button", "get_status", "form1", "form2", "card1", "txt_start"];
  for (var i = 1; i <= NS; i++) KEYS.push("sw_start_" + i, "sw_end_" + i, "txt_start_" + i, "txt_end_" + i);
  var LABELS = { check_t: "检查项 1.1", check_h: "检查项 1.1", battery_table1: "检查项 2.3 电池内阻", soh: "检查项 2.3.1", cca_all: "检查项 2.3.2", A_M: "检查项 3.7", get_data_button: "检查项 3.7 获取数据", get_status: "检查项 3.7", form1: "检查项 3.7 测点数据", form2: "检查项 3.7 测点数据", card1: "检查项 3.7 人工记录", txt_start: "开始维护" };
  STEPS.forEach(function (st) {
    var n = st.no;
    LABELS["sw_start_" + n] = LABELS["txt_start_" + n] = n === 1 ? "开始维护" : "步骤 " + stepSn(n) + " 开始";
    LABELS["sw_end_" + n] = LABELS["txt_end_" + n] = "步骤 " + stepSn(n) + " 结束";
  });
  ITEMS.forEach(function (it) {
    if (!it.hasCk) return;
    ["ck_", "txt_aa_", "txt_ed_"].forEach(function (p) {
      KEYS.push(p + it.id);
      LABELS[p + it.id] = "检查项 " + it.sn;
    });
  });

  var ADAPTER = {
    name: "middle_dg",
    started: function () { return swS(1); },
    startTime: function () { return v("txt_start") || v("txt_start_1"); },
    allDone: function () { return swE(NS); },
    abnormalCount: function () { return ITEMS.filter(isAbn).length; },
    abnormalList: function () {
      return ITEMS.filter(isAbn).map(function (it) {
        return { sn: it.sn, title: it.title, desc: [biz.joinVals(v("txt_aa_" + it.id)), biz.joinVals(v("txt_ed_" + it.id))].filter(Boolean).join("：") };
      });
    },
    stepText: function () {
      var d = 0;
      for (var n = 1; n <= NS; n++) if (swE(n)) d++;
      return d + " / " + NS + " 个步骤";
    },
    keys: function () { return KEYS; },
    labels: LABELS,
  };

  /** 检查项文案随表单提交（后端结单时写入异常明细：txt_m_XXX / txt_s_XXX） */
  function seedTexts() {
    var o = {};
    ITEMS.forEach(function (it) {
      var name = STEPS[it.step - 1].name;
      if (v("txt_n_" + it.id) !== name) o["txt_n_" + it.id] = name;
      if (v("txt_m_" + it.id) !== it.m) o["txt_m_" + it.id] = it.m;
      if (v("txt_s_" + it.id) !== it.s) o["txt_s_" + it.id] = it.s;
    });
    if (empty(v("A_M"))) o.A_M = "手动";
    if (Object.keys(o).length) store.patch(o, { silent: true });
  }

  biz.part({
    name: "middle_dg",
    title: "检查清单",
    middle: ADAPTER,
    fold: fold,
    render: function (ctx) {
      return h("div", { class: ["mw-middle", "mw-middle--dg", !swS(1) && "is-locked"] },
        overview(ctx),
        h("div", { class: "mw-steplist" }, STEPS.map(function (st) { return stepCard(st, ctx); })));
    },
    errors: function () {
      var e = [];
      for (var n = 1; n <= NS; n++) e = e.concat(stepErrors(n));
      return e;
    },
    mounted: function () { seedTexts(); },
    /** "回到上次填写的位置"：检查项所在步骤已折叠时先展开 */
    reveal: function (k) {
      var m = /^dg\.(\d+)\./.exec(k || "");
      var it = m && BY_ID[m[1]];
      if (!it || !swS(it.step)) return false;
      collapsed[it.step] = false;
      store.touch();
      return true;
    },
  });
}
